module.exports = __webpack_public_path__ + "static/media/33_tn.a0607df2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/33_tn.jpg
// module id = 171
// module chunks = 0